import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CreateSingleAddress from './CreateSingleAddress';
import CreateBulkAddresses from './CreateBulkAddresses';
import UpdateAddress from './UpdateAddress';
import ResultTable from './ResultTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

export default function UnofficialAddress() {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("single-address");
    const [activeSubTab, setActiveSubTab] = useState("create_address-section");
    const [resultData, setResultData] = useState({
        data: null,
        loading: false,
        msg: ""
    });
    const [tableData, setTableData] = useState({
        header: [],
        data: []
    });

    const [textAreaContent, setTextAreaContent] = useState({
        header: [],
        data: [],
        errors: []
    });
    const [pageSubmit, setPageSubmit] = useState();
    const resetResult = () => {
        setResultData({
            data: null,
            loading: false,
            msg: ""
        });
    }
    return (
        <div className="main-content">
            <div className="row ">
                <div className="col-lg-12 col-md-12">
                    <div className="card" style={{ minHeight: 200 }}>
                        <div className="card-content">
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link mr-1 active" id="single-address" style={{ minWidth: "10rem" }} data-toggle="tab" href="#single-address-tab" role="tab" aria-controls="search" aria-selected="true"
                                        onClick={() => { setActiveTab("single-address");}}>
                                        Single Address
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link mr-1" id="bulk-address" data-toggle="tab" href="#bulk-address-section" style={{ minWidth: "12rem" }} role="tab" aria-controls="search" aria-selected="true"
                                        onClick={() => { setActiveTab("bulk-address");}}>
                                        Bulk Address
                                    </button>
                                </li>
                            </ul>
                            <div className="tab-content" id="">
                                <div className="tab-pane fade show active" style={{ marginTop: "1rem" }} id="single-address-tab" role="tabpanel" aria-labelledby="search-tab">
                                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link mr-1 active" id="create-address" style={{ minWidth: "10rem" }} data-toggle="tab" href="#create_address-section" role="tab" aria-controls="search" aria-selected="true"
                                                onClick={() => { setActiveSubTab("create_address-section");}}>
                                                Create Address
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link mr-1" id="update-address" data-toggle="tab" href="#update_address-section" style={{ minWidth: "12rem" }} role="tab" aria-controls="search" aria-selected="true"
                                                onClick={() => { setActiveSubTab("update_address-section"); resetResult(); }}>
                                                Update Address
                                            </button>
                                        </li>
                                    </ul>
                                    <div className="tab-content" id="myTabContent" style={{ marginTop: "16px" }}>
                                        <div className="tab-pane fade show active" id="create_address-section" role="tabpanel" aria-labelledby="search-tab">
                                            {activeSubTab === "create_address-section" &&
                                                <CreateSingleAddress tabName={activeTab}/>
                                            }
                                        </div>
                                        <div className="tab-pane fade" id="update_address-section" role="tabpanel" aria-labelledby="update_address-section">
                                            {activeSubTab === "update_address-section" && <UpdateAddress tabName={activeTab} setResultData={setResultData} setSearchSubmit={setPageSubmit} resetFeilds="true"/>}
                                        </div>
                                    </div>
                                </div>

                                <div className="tab-pane fade" id="bulk-address-section" role="tabpanel" aria-labelledby="search-tab">
                                    <CreateBulkAddresses tabName={activeTab} setTableData={setTableData} setTextAreaContent={setTextAreaContent} />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {(activeTab === "single-address" && activeSubTab !== "create_address-section") &&
                    <div className="col-lg-12 col-md-12">
                        <div className="card" style={{ minHeight: 200, fontSize: "0.8rem" }}>
                            {activeSubTab === "update_address-section" &&
                                (resultData.data?.content?.length > 0 ? <ResultTable tableData={resultData.data} pageSubmit={pageSubmit} showGeoCode={false} />
                                    : <div className="text-center py-4">
                                        <FontAwesomeIcon icon={faSearch} size="6x" color="#6c757d" spin={resultData.loading} />
                                        <h3 className="mt-3">{resultData.msg ? resultData.msg : t('result.searchMsg')}</h3>
                                    </div>)}
                        </div>
                    </div>
                }
                {activeTab === "bulk-address" &&
                    <div className="col-lg-12 col-md-12">
                        <div className="card" style={{ minHeight: 200, fontSize: "0.8rem" }}>
                            {/* Table to display validated data */}

                            {tableData.data.length > 0 && (
                                <div className="table-responsive">

                                    {/* Determine if ANY row contains ANY error */}
                                    {(() => {
                                        const hasAnyErrors =
                                            tableData?.data?.some(
                                                row => row.fieldErrors && Object.keys(row.fieldErrors).length > 0
                                            );

                                        return (
                                            <table
                                                className="table table-hover table-sm table-striped table-bordered"
                                                style={{ whiteSpace: "nowrap" }}
                                            >
                                                <thead>
                                                    <tr className="table-active">
                                                        {tableData.header.map((data) => (
                                                            <th key={data}>{data}</th>
                                                        ))}

                                                        {/* Only show Errors column if needed */}
                                                        {hasAnyErrors && <th style={{ color: "red" }}>Validation Status</th>}
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {tableData.data.map((row, rowIndex) => {
                                                        const isDuplicate = row.isDuplicate;
                                                        const hasBackendError = row.fieldErrors && row.fieldErrors.backend;

                                                        return (
                                                            <tr
                                                                key={rowIndex}
                                                                style={{
                                                                    backgroundColor:
                                                                        hasBackendError
                                                                            ? "#ffcccc"      // Backend error highlight
                                                                            : isDuplicate
                                                                                ? "#ffe6e6"  // Duplicate row highlight
                                                                                : undefined,
                                                                    borderLeft: hasBackendError
                                                                        ? "4px solid red"
                                                                        : isDuplicate
                                                                            ? "4px solid orange"
                                                                            : undefined,
                                                                }}
                                                            >
                                                                {/* Render CSV Data Fields */}
                                                                {tableData.header.map((column, colIndex) => {
                                                                    const hasError =
                                                                        row.fieldErrors && row.fieldErrors[column];

                                                                    return (
                                                                        <td
                                                                            key={colIndex}
                                                                            style={{
                                                                                backgroundColor: hasError ? "#fdd" : undefined,
                                                                            }}
                                                                        >
                                                                            {row[column] || ""}

                                                                            {hasError && (
                                                                                <div style={{ color: "red", fontSize: "12px" }}>
                                                                                    {row.fieldErrors[column]}
                                                                                </div>
                                                                            )}
                                                                        </td>
                                                                    );
                                                                })}

                                                                {/* Errors Column (conditionally rendered) */}
                                                                {hasAnyErrors && (
                                                                    <td>
                                                                        {Object.keys(row.fieldErrors).length > 0 ? (
                                                                            <ul
                                                                                style={{
                                                                                    paddingLeft: 16,
                                                                                    margin: 0,
                                                                                    color: "red",
                                                                                    fontSize: "12px"
                                                                                }}
                                                                            >
                                                                                {Object.entries(row.fieldErrors).map(([field, msg]) => (
                                                                                    <li key={field}>{msg}</li>
                                                                                ))}
                                                                            </ul>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </td>
                                                                )}
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        );
                                    })()}

                                </div>
                            )}

                            {textAreaContent.data.length > 0 && (
                                <div className="table-responsive">
                                    <table className="table table-hover table-sm table-striped table-bordered" style={{ whiteSpace: "nowrap" }}>
                                        <thead>
                                            <tr>
                                                {textAreaContent.header.map((h, i) => <th key={i}>{h}</th>)}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {textAreaContent.data.map((row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    {row.map((cell, colIndex) => {
                                                        const headerValue = textAreaContent.header[colIndex];
                                                        const error = textAreaContent.errors[rowIndex][headerValue];
                                                        return (
                                                            <td key={colIndex} style={{ backgroundColor: error ? '#fdd' : undefined }}>
                                                                {cell}
                                                                {error && <div style={{ color: 'red', fontSize: '12px' }}>{error}</div>}
                                                            </td>
                                                        );
                                                    })}
                                                    {/* <td style={{ color: 'red', fontSize: '13px' }}>
												{errors[rowIndex]['_row'] || ''}
											</td> */}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}